import {
    SYSTEM_ALT_LOG_CONTACTS_OPEN_MODAL,
    SYSTEM_ALT_LOG_CONTACTS_REQUEST,
    SYSTEM_ALT_LOG_CONTACTS_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";
import { filter } from "lodash";

const INIT_STATE = {
    openModal: false,
    contact: null,
    filters: null,
    messagesDetails: [],
    loading: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case SYSTEM_ALT_LOG_CONTACTS_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, contact: action.payload.contact, filters: action.payload.filters }

        case SYSTEM_ALT_LOG_CONTACTS_REQUEST:
            return { ...state, loading: true }

        case SYSTEM_ALT_LOG_CONTACTS_RESULT:
            return { ...state, loading: false, messagesDetails: action.payload.result.items || [] }

        case CLEAR_REDUX:
            return ["", "SYSTEM_ALT_LOG_CONTACTS"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};